module.exports = __webpack_public_path__ + "img/logo_black.42236ce1.png";